<template>
  <div class="page">
    <div class="flex-aligncol-center" style="margin-top: 150px">
      <img class="topic-icon" src="@/assets/topicIcon.png" />
      <div class="title-1" style="font-size: 22px; padding: 20px 0 30px 0">
        {{ queryRecord?.name || '请选择测评' }}
      </div>
      <div>
        <span class="tip">共{{ baseInfo?.allNum || 0 }}个测评</span>
        <span class="tip">题数：{{ baseInfo?.allTopicNum || 0 }}题</span>
        <span class="tip">预计用时：{{ baseInfo?.allTime || 0 }}分钟</span>
      </div>
      <div class="flex-align-center" style="padding: 20px 0">
        <a-select
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          v-model="formData.evalId"
          placeholder="请选择测评"
          class="selet-stu"
          :options="evaluationList"
          @select="selectEvalInfo"
        />
        <j-dict-select-tag
          v-if="isShowCom"
          class="selet-stu"
          placeholder="请选择年级"
          v-model="formData.gradeId"
          dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
          :optionalVals="queryRecord.gradeIds"
          :disabled="!formData.evalId"
          :isShowEmpty="false"
          @setDefaultValue="setDefaultGrade"
          @select="(record) => selectStuInfo('grade', record)"
        />
        <j-dict-select-tag
          class="selet-stu"
          placeholder="请选择班级"
          v-model="formData.classId"
          :dictCode="
            'school_class,name,id,grade_id=' + (!formData.gradeId ? -1 : formData.gradeId)
          "
          :async="true"
          :disabled="!formData.gradeId"
          :isShowEmpty="false"
          @select="(record) => selectStuInfo('class', record)"
        />
        <a-select
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          v-model="formData.studentId"
          placeholder="请选择学生"
          class="selet-stu"
          :disabled="!formData.classId"
          :options="classStuList"
          @change="changeStuInfo"
        />
      </div>
      <div style="margin-bottom: 20px">
        <img v-if="currSelectStu.pic" :src="currSelectStu.pic" alt="学生图片" class="stu-pic" />
      </div>
      <a-button type="primary" style="width: 260px; height: 36px" @click="submitStuInfo">
        开始答题
      </a-button>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { getStoreHttpUrl } from '@/utils/util'
import Vue from 'vue'
import { TOPIC_RECORD } from '@/store/mutation-types'

export default {
  name: 'FillOutStuInfo',
  props: {
    baseArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {},
      evaluationList: [],
      classStuList: [],
      currSelectStu: {},
      queryRecord: {},
      baseInfo: {},
      isShowCom: true,
      evalPlanObj: {},
      meterList: [],
    }
  },
  created() {
    this.queryRecord = Vue.ls.get(TOPIC_RECORD)?.queryRecord || {}
    this.getSchoolEvaluationPlan()
  },
  watch: {
    baseArr: {
      handler(val) {
        if (!val.length) return
        const allNum = val.length
        console.log('baseArr---', this.baseArr)
        const allTopicNum = val?.reduce((acc, cur) => acc + cur.num, 0)
        const allTime = val?.reduce((acc, cur) => {
          if (cur.time) {
            return acc + Number(cur.time.split('分钟')[0])
          }
        }, 0)
        console.log('allTime---', allTime)
        this.baseInfo = {
          allNum,
          allTopicNum,
          allTime,
        }
      },
    },
  },
  methods: {
    getSchoolEvaluationPlan() {
      getAction('/schoolEvaluationPlan/list', {
        pageNo: 1,
        pageSize: 1000,
        status: 1,
      }).then((res) => {
        if (res.success) {
          console.log('测评信息：', res.result)
          this.evaluationList = res.result.records?.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }))
        }
      })
    },
    setDefaultGrade(record) {
      // this.$set(this.formData, 'gradeId', record[0].value)
      // this.currGradeName = record[0].title
    },
    selectStuInfo(type, record) {
      console.log(record,type)
      switch (type) {
        case 'grade':
          this.formData.classId = undefined
          break
      }
      this.formData.studentId = undefined
      this.currSelectStu = {}
      if (record.id || record.value) {
        this.getStudentInfo()
      }
    },
    selectEvalInfo(val) {
      this.queryRecord = this.evaluationList.find((item) => item.value === val)
      console.log('选择测评信息：', this.queryRecord)
      this.$set(this.formData, 'gradeId', undefined)
      this.$set(this.formData, 'classId', undefined)
      this.$set(this.formData, 'studentId', undefined)
      this.isShowCom = false
      this.getEvaluationByPlanId()
      this.$nextTick(() => {
        this.isShowCom = true
      })
    },
    getEvaluationByPlanId() {
      getAction('/schoolEvaluationPlan/getEvaluationByPlanId', {
        planId: this.queryRecord.id,
      }).then((res) => {
        if (res.success) {
          const allNum = res.result.length
          this.meterList = res.result
          const allTopicNum = res.result.reduce((acc, cur) => acc + cur.num, 0)
          const allTime = res.result.reduce((acc, cur) => {
            if (cur.time) {
              return acc + Number(cur.time.split('分钟')[0])
            }
          }, 0)
          this.baseInfo = {
            allNum,
            allTopicNum,
            allTime,
          }
        }
      })
    },
    changeStuInfo(val) {
      this.currSelectStu = this.classStuList.find((item) => item.value === val)
    },
    getStudentInfo() {
      getAction('/aigoes/studentInfo/list', {
        classId: this.formData.classId,
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.classStuList =
            res.result?.records?.map((item) => ({
              ...item,
              pic: getStoreHttpUrl(item.pic),
              value: item.id,
              label: item.name,
            })) || []
        }
      })
    },
    submitStuInfo() {
      if (!this.formData.evalId) {
        this.$message.error('请选择测评')
        return
      }
      if (!this.formData.studentId) {
        this.$message.error('请填写学生个人信息')
        return
      }
      this.$emit('submitStuInfo', this.formData, this.queryRecord, this.meterList)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>
<style scoped lang="less">
.page {
  display: flex;
  justify-content: center;
  min-height: 90vh;
  background-color: #fff;
  border-radius: 10px;
}
.selet-stu {
  width: 220px;
  padding: 10px;
}
.topic-icon {
  width: 100px;
  height: 100px;
}
.tip {
  padding: 0 20px;
}
.stu-pic {
  width: 120px;
  height: auto;
  border: 1px solid #1890ff;
  border-radius: 6px;
}
</style>
